import { EventListItemViewModel } from "../EventListItemViewModel.csharp";
import React from "react";

export const EventListItem = (props: EventListItemViewModel) => {
        return (
            <div className="EventListItem">
                <a href={props.url} title={props.title}>
                    <h2
                        className="EventListItem__title"
                    >
                        {props.title}
                        <span className="EventListItem__subtitle">{props.subtitle}</span>
                    </h2>
                    <div className="EventListItem__intro">
                        <span>{props.dateString}<br /></span>
                        <span>{props.location}</span>
                    </div>
                </a>
            </div>
        );
    };